var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import lodash from 'lodash';
import { observer } from 'mobx-vue';
import { Component, Vue } from 'vue-property-decorator';
let default_1 = class extends Vue {
    get languages() {
        return lodash.keys(this.$i18n.messages);
    }
    getLanguageIcons(key) {
        return lodash.get({
            zh: '🇨🇳',
            // 'zh-TW': '🇭🇰',
            en: '🇬🇧',
            // 'pt-BR': '🇧🇷',
        }, key);
    }
    onChangeLanguage(event) {
        this.AppConfig.onChangeAppSettings({ type: 'language', value: event.key });
    }
    onSearch() { }
    mounted() { }
    updated() { }
    destroyed() { }
};
default_1 = __decorate([
    observer,
    Component({
        components: {},
    })
], default_1);
export default default_1;
